import { render } from "./payment2.vue?vue&type=template&id=45ccd9eb&scoped=true"
import script from "./payment2.vue?vue&type=script&lang=js"
export * from "./payment2.vue?vue&type=script&lang=js"

import "./payment2.vue?vue&type=style&index=0&id=45ccd9eb&scoped=true&lang=css"

import exportComponent from "C:\\Users\\user\\Desktop\\tapit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45ccd9eb"]])

export default __exports__